import { HandbookRefField, TextField } from "./HandbookFormControls";
import { HandbookFormProps, makeIsRequired } from "./handbookFormProps";

type Props = HandbookFormProps & { language: "ru" | "ky" };

/** Ссылки на другие справочники и порядок выполнения. */
export const HandbookRefFields = ({ language, ...p }: Props) => {
  const isRequired = makeIsRequired(p.requiredFields);

  return (
    <>
      {p.showType && p.typeFieldKey && (
        <HandbookRefField
          name="typeId"
          label="Тип"
          message="Укажите тип"
          required={isRequired(`${p.typeFieldKey}Id`)}
          fieldKey={p.typeFieldKey}
          initial={p.initial}
          language={language}
        />
      )}

      {p.showCategory && p.categoryFieldKey && (
        <HandbookRefField
          name="categoryId"
          label="Категория"
          message="Укажите категорию"
          required={isRequired(`${p.categoryFieldKey}Id`)}
          fieldKey={p.categoryFieldKey}
          initial={p.initial}
          language={language}
        />
      )}

      {p.showCrop && p.cropFieldKey && (
        <HandbookRefField
          name="cropId"
          label="Урожай"
          message="Укажите урожай"
          required={isRequired(`${p.cropFieldKey}Id`)}
          fieldKey={p.cropFieldKey}
          initial={p.initial}
          language={language}
        />
      )}

      {p.showUnitMeasurement && p.unitMeasurementFieldKey && (
        <HandbookRefField
          name="unitMeasurementId"
          label="Единица измерения"
          message="Укажите единицу измерения"
          required={isRequired(`${p.unitMeasurementFieldKey}Id`)}
          fieldKey={p.unitMeasurementFieldKey}
          initial={p.initial}
          language={language}
        />
      )}

      {p.showOrder && (
        <TextField
          name="order"
          label="Порядок выполнения"
          message="Укажите порядок"
          required={isRequired("order")}
          type="number"
          min={1}
        />
      )}

      {p.showThresholdPerM2 && (
        <TextField
          name="thresholdPerM2"
          label="Порог вредоносности, экз./м²"
          message="Укажите порог вредоносности"
          required={isRequired("thresholdPerM2")}
          type="number"
          min={0}
          step="any"
        />
      )}
    </>
  );
};
